import { render, staticRenderFns } from "./TransferredStatus.vue?vue&type=template&id=4d274ba2&scoped=true&"
import script from "./TransferredStatus.vue?vue&type=script&lang=js&"
export * from "./TransferredStatus.vue?vue&type=script&lang=js&"
import style0 from "./TransferredStatus.vue?vue&type=style&index=0&id=4d274ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d274ba2",
  null
  
)

export default component.exports